import { Box } from '@material-ui/core';
import { FlexBox } from 'component/customize_style_component/styled_box';
import InfoFieldItem from 'component/info_field_item';
import { use100vh } from 'react-div-100vh';
import themes from 'styles/themes';
import utils from 'utils/utils';
import styles from './style.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import UserType from 'constants/user';
import { ItemStyleAccess } from '__generated__/globalTypes';

function ViewInfomationStyle(props) {
    const { item } = props;
    const userDetail = useSelector((state: RootState) => state?.userDetail?.me);
    // console.log("item",item);
    const height: any = use100vh();
    return (
        <Box px={0} mt={0}>
            <form
                autoComplete="off"
                style={{
                    margin: 0,
                    padding: 0,
                    minHeight: `${height - 58 - 24}px`,
                    overflowY: 'scroll',
                }}
                className={styles.forminfo}
            >
                <FlexBox flexdirection={'column'} margin={'0 0 10px 0'}>
                    <InfoFieldItem label={'Title'} content={item?.title} />
                </FlexBox>
                <FlexBox flexdirection={'column'} margin={'0 0 10px 0'}>
                    <InfoFieldItem label={'Description'} content={item?.description} />
                </FlexBox>
                {item?.collection === 'items' ? (
                    <>
                        <FlexBox flexdirection={'column'} margin={'0 0 10px 0'}>
                            <InfoFieldItem label={'Brand'} content={item?.brand?.name} />
                        </FlexBox>
                        <FlexBox flexdirection={'column'} margin={'0 0 10px 0'}>
                            <InfoFieldItem label={'Colors'} content={item?.colors?.toString()} />
                        </FlexBox>
                        <FlexBox flexdirection={'column'} margin={'0 0 10px 0'}>
                            <InfoFieldItem label={'Sizes'} content={item?.sizes?.toString()} />
                        </FlexBox>
                        {userDetail?.userType === UserType.Stylist &&
                            (item?.creator === userDetail?.id || item?.accessLevel === ItemStyleAccess.PUBLIC) && (
                            <FlexBox flexdirection={'column'} margin={'0 0 10px 0'}>
                                <InfoFieldItem label={'Tags'} content={item?.tags?.toString()} />
                            </FlexBox>
                        )}
                    </>
                ) : (
                    <>
                        <FlexBox flexdirection={'column'} margin={'0 0 10px 0'}>
                            <InfoFieldItem label={'Categories'} content={item?.categories?.toString()} />
                        </FlexBox>
                        <FlexBox flexdirection={'column'} margin={'0 0 10px 0'}>
                            <InfoFieldItem label={'Purposes'} content={item?.purposes?.toString()} />
                        </FlexBox>
                        <FlexBox flexdirection={'column'} margin={'0 0 10px 0'}>
                            <InfoFieldItem label={'Ages'} content={item?.ages?.toString()} />
                        </FlexBox>
                        <FlexBox flexdirection={'column'} margin={'0 0 10px 0'}>
                            <InfoFieldItem label={'Body Shapes'} content={item?.bodyShapes?.toString()} />
                        </FlexBox>
                        <FlexBox flexdirection={'column'} margin={'0 0 10px 0'}>
                            <InfoFieldItem label={'Body Types'} content={item?.bodyTypes?.toString()} />
                        </FlexBox>
                        <FlexBox flexdirection={'column'} margin={'0 0 10px 0'}>
                            <InfoFieldItem label={'Seasons'} content={item?.seasons?.toString()} />
                        </FlexBox>
                    </>
                )}

                {item?.price !== 0 && (
                    <p
                        style={{
                            fontSize: 16,
                            fontWeight: 'bold',
                            fontFamily: 'PoppinsRegular',
                            color: themes.palette.primary.dark,
                            borderBottom: `1px solid ${themes.palette.grey['500']}`,
                            padding: '10px 0',
                        }}
                    >
                        Total Price :{' '}
                        <span style={{ color: themes.palette.primary.main }}>
                            {utils.getPrice(item?.price, item?.currency)}
                        </span>{' '}
                    </p>
                )}
                <FlexBox flexdirection={'column'} margin={'0 0 10px 0'}>
                    <InfoFieldItem label={'Taffi Id'} content={item?.taffiId} />
                </FlexBox>
            </form>
        </Box>
    );
}

export default ViewInfomationStyle;
